module.exports = __webpack_public_path__ + "img/menu-plus-on.2b4a94b7.svg";